export default "__VITE_ASSET__C2vqE1lH__"